<template>
    <v-menu offset-y v-model="notificationMenu" :close-on-content-click="false" :close-on-click="true" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on: activationEvents }">
            <v-tooltip :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" :disabled="utils.isMobile()" open-delay="500" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                        <v-badge :value="notificationBadge" color="orange" dot overlap offset-x="17" offset-y="17">
                            <v-btn
                                tag="a"
                                class="link-menu"
                                :height="$vuetify.breakpoint.xs ? 30 : 46"
                                min-width="30"
                                :width="$vuetify.breakpoint.xs ? 30 : 50"
                                text
                                v-on="activationEvents"
                            >
                                <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-bell-outline</v-icon>
                            </v-btn>
                        </v-badge>
                    </span>
                </template>
                <span>{{ $t('menu.notifications') }}</span>
            </v-tooltip>
        </template>

        <v-card width="350px" outlined>
            <v-list>
                <v-list-item-content class="pb-0 pt-0">
                    <span class="px-2" v-if="filterNotifications.length">
                        <span v-for="(notification, index) in filterNotifications" :key="index">
                            <v-list-item>
                                <v-row class="py-2">
                                    <v-col cols="2" class="pr-0 pl-0">
                                        <span class="grey--text">
                                            {{ notification.created_at | formatInTimeZone('MMM dd', true) }}
                                        </span>
                                    </v-col>
                                    <v-col cols="10" class="pl-0">
                                        <span v-html="getNotificationText(notification)"></span>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </span>
                    </span>
                    <span v-else>
                        <p class="text-center mb-0 pt-1 pb-1 font-weight-light">
                            {{ $t('menu.noUnreadNotifications') }}
                        </p>
                    </span>

                    <v-col cols="6" class="pb-0 pt-0 pl-2">
                        <v-btn tag="a" :color="$vuetify.theme.dark ? 'white' : 'grey'" text class="px-1">
                            <router-link to="/notifications" @click.native="notificationMenu = false">
                                {{ $t('menu.allNotifications') }}
                            </router-link>
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right pb-0 pt-0 pr-2">
                        <v-btn tag="a" v-if="filterNotifications.length" color="grey" text class="px-1">
                            <a @click="dismissAll">
                                {{ $t('menu.dismissAll') }}
                            </a>
                        </v-btn>
                    </v-col>
                </v-list-item-content>
            </v-list>
        </v-card>
    </v-menu>
</template>
<style scoped>
    .v-list-item:hover {
        background-color: #fafafa;
    }

    .theme--dark .v-list-item:hover {
        background-color: #2b2c30;
    }
    .v-list-item {
        min-height: 40px;
    }
</style>
<script>
    import { eventBus } from '~/app';

    export default {
        name: 'app-menuNotification',
        components: {},
        data() {
            return {};
        },

        created() {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            getNotificationText(notification) {
                if (this.$i18n.locale === 'pt') {
                    return notification.text_pt;
                }

                return notification.text_en;
            },
            dismissAll() {
                this.$store.dispatch('NotificationModule/dismissAll').then((response) => {
                    if (response.data.success) {
                        this.notifications = [];
                        this.notificationMenu = false;
                        this.notificationBadge = false;

                        eventBus.$emit('pageResize');
                    }
                });
            },
        },

        computed: {
            filterNotifications() {
                let notifications = this.notifications;

                return notifications ? notifications.slice(0, 5) : [];
            },

            notificationBadge: {
                get() {
                    return this.$store.getters['MenuModule/getNotificationBadge'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setNotificationBadge', value);
                },
            },

            notifications: {
                get() {
                    return this.$store.state['NotificationModule'].notViewedNotifications;
                },
                set(value) {
                    this.$store.commit('NotificationModule/setNotViewedNotifications', value);
                },
            },

            notificationMenu: {
                get() {
                    return this.$store.getters['MenuModule/getNotificationMenu'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setNotificationMenu', value);
                },
            },

            options: {
                get() {
                    return this.$store.getters['PageModule/getOptions'];
                },
                set(value) {
                    value.sortBy[0] = value.sortBy[0] ? value.sortBy[0] : 'id';
                    this.$store.commit('PageModule/setOptions', value);
                },
            },
        },
    };
</script>
